/* global axios */
import ApiClient from './ApiClient';

// O recorte da aba Campanhas, como a API o recebe. since/until: 'YYYY-MM-DD',
// inclusivos, no fuso da conta. Filtro vazio é "todos" e não vai na query.
// `agentId` é o agente de IA (PowerAgent), por cujo robô o disparo sai. A
// campanha (`campaignKeys`: `campanha:<id>` ou `lote:<uuid>`), o template e o
// segmento são listas. Time e atendente não vão: o disparo não tem nenhum dos
// dois, e a API os ignoraria.
export const queryParams = ({
  since,
  until,
  includeTests = false,
  agentId,
  inboxId,
  campaignKeys,
  templates,
  segments,
} = {}) => ({
  since,
  until,
  include_tests: includeTests,
  agent_ids: agentId ? [agentId] : undefined,
  inbox_id: inboxId || undefined,
  campaign_keys: campaignKeys?.length ? campaignKeys : undefined,
  templates: templates?.length ? templates : undefined,
  segments: segments?.length ? segments : undefined,
});

// Uma rota por seção (`campanhas/*`): cada seção pede a sua, e a falha de uma
// não apaga as outras. O detalhe operacional (`operational`) só vem na resposta
// de super admin — quem corta é o servidor.
class CampanhasReportAPI extends ApiClient {
  constructor() {
    super('campanhas', { accountScoped: true });
  }

  section(name, filters, extra = {}) {
    return axios.get(`${this.url}/${name}`, {
      params: { ...queryParams(filters), ...extra },
    });
  }

  // As campanhas, os templates e os segmentos que o filtro oferece.
  opcoes(filters) {
    return this.section('opcoes', filters);
  }

  resumo(filters) {
    return this.section('resumo', filters);
  }

  // `sort`: uma coluna da tabela, com `-` na frente para a ordem decrescente.
  tabela(filters, { sort, page = 1 } = {}) {
    return this.section('tabela', filters, { sort: sort || undefined, page });
  }

  mapa(filters) {
    return this.section('mapa', filters);
  }

  // by: template | segment
  comparar(filters, by = 'template') {
    return this.section('comparar', filters, { by });
  }

  falhas(filters) {
    return this.section('falhas', filters);
  }

  linhaDoTempo(filters) {
    return this.section('linha_do_tempo', filters);
  }

  // As conversas de uma linha (replied | ai | person | other_bot | nobody |
  // waiting | no_reply | failed | opted_out), de 25 em 25. Sem telefone.
  conversas(filters, line, page = 1) {
    return this.section('conversas', filters, { line, page });
  }

  // Quem pediu para parar, de 25 em 25.
  descadastros(filters, page = 1) {
    return this.section('descadastros', filters, { page });
  }

  // O custo da Meta, estimado, e o da IA: só o super admin. O servidor responde
  // 403 para os outros, e a tela nem pede.
  custo(filters) {
    return this.section('custo', filters);
  }

  // Desfazer um pedido para parar: só o administrador. A linha fica, com a data
  // de quando foi desfeito.
  desfazerDescadastro(id) {
    return axios.delete(`${this.baseUrl()}/contact_opt_outs/${id}`);
  }
}

export default new CampanhasReportAPI();
